import { DisplayAdDef } from 'models/common/ads-types';

// Display ads have arbitrary breakpoints that do not align with bernie
export const DisplayAd: DisplayAdDef = {
  SIDERAIL_R1: {
    uci: 'R1',
    className: 'uitk-grid'
  },
  SIDERAIL_R2: {
    uci: 'R2',
    className: 'uitk-grid sticky-top__with-navbar'
  },
  SIDERAIL_RM: {
    uci: 'RM',
    className: 'uitk-grid'
  },

  FOOTER_CM6: { uci: 'CM6' },
  FOOTER_CM3: { uci: 'CM3' },
  FOOTER_CM2: { uci: 'CM2' },
  FOOTER_CM1: { uci: 'CM1' }
};
